// Converted to lazy loading
const branches = () => import('@/pages/branches/index.vue')
const branchesForm = () => import('@/pages/branches/form.vue')

const routes = [
  {
    path: 'branches',
    name: 'branches',
    component: branches
  },
  {
    path: 'branches/create',
    name: 'branchesCreate',
    component: branchesForm
  },

  {
    path: 'branches/:id/edit',
    name: 'branchesEdit',
    component: branchesForm
  }
]

export default routes
